import { Pricing } from "./hotel-product.interface";
import { ExtraService, IProductBase, IProductReservationBase, IProductResult, Profility } from "./product.interface";

export interface ExperienceResult extends IProductResult {
  results: ExperienceModelResult[];
}
export interface ExperienceModelResult {
    providerId: string;
    providerName: string;
    logo_tours_prov: string;
    id: number;
    title: string;
    description: string;
    categoryId: number;
    product_Id: number;
    origin: string;
    destination: string;
    dateIni: Date;
    dateEnd: Date;
    institutional_video_link: string;
    commercial_video_link: string;
    serviceResponse: any;
    scheduling: any;
    nameAdapter: string;
    additionalInfo: AdditionalInfoExperienceResult,
}

export interface AdditionalInfoExperienceResult {
  currency: string;
  location: string;
  location_gps: {
    longitude: string | null;
    latitude: string | null;
  },
  default_img: string;
  images: ImagesExperienceResult[],
  specialNotes: any[],
  operationDays: OperationDaysExperienceResult[],
  general_info: string;
  extra_info: string;
  tours: ToursExperienceResult
}

export interface ToursExperienceResult {
  company: string;
  hasReservationQuestions: boolean;
  options: OptionsExperienceResult[]
}

export interface OptionsExperienceResult {
  option_name: string;
  optionId: string;
  rateClass: string;
  duration: string;
  language: string;
  languageId: number;
  isoCode: string;
  sessions: string;
  currency: string;
  totalPrice: number;
  bookParam: string;
  paxPrices: PaxPricesExperienceResult[],
  availableDates: AvailableDatesExperienceResult[],
  questions: any[];
  cancellation_policy: any[];
  profility: Profility;
  pricing: Pricing;
  prices: PricesExperiencesResult[];
}

export interface PricesExperiencesResult {

}

export interface AvailableDatesExperienceResult {
  from: Date;
  to: Date;
  cancellationPolicies: CancellationPoliciesExperienceResult[]
}

export interface CancellationPoliciesExperienceResult {
  dateFrom: Date;
  amount: number;
  descriptPolicy: string;
  paymentLimitDay: string | null;
}

export interface PaxPricesExperienceResult {
  paxType: string;
  ageFrom: number;
  ageTo: number;
  amount: number;
  boxOfficeAmount: number;
  mandatoryApplyAmount: boolean;
}

export interface OperationDaysExperienceResult {
  code: string;
  name: string;
}

export interface ImagesExperienceResult {
  description: string;
  image: string;
  thumbnail: string;
  isCover: boolean;
}


export interface IExperiencieProduct extends IProductBase {
  addonsIncluded: [];
  adults: number;
  arrivalDate: Date;
  departureDate: Date;
  blickoins: number;
  blickoinsFactor: number;
  creditBlickoins: number;
  creditFactor: number;
  bookParam: number;
  categoryName: string;
  categoryId: number;
  childrens: number;
  currency: string;
  expiration_date: Date;
  dateEnd: Date;
  dateStart: Date;
  description: string;
  destination: DestinationExperience;
  experience: OptionExperienceProduct;
  form: formExperience;
  id: any;
  IdProduct: any;
  images: string[];
  institutional_video_link: string;
  location: string;
  logo: string;
  nameAdapter: string;
  netPrice: number;
  netPriceFreeTax: number;
  netPriceUnitary: number;
  origin: string;
  paxNumber: number;
  paxPricing: PricingExperience[];
  paxProfility: PaxProfilityExperience[];
  paxesData: PaxesDataExperience[];
  payload: PayloadExperience[];
  payloadUpdate: PayloadUpdateExperience;
  percentage: number;
  pricing: any;
  pricingOriginal: PricingExperience[];
  productkey: number;
  productId: string;
  productName: string;
  profility: Profility;
  profilityOriginal: PaxProfilityExperience[];
  providerId: string;
  providerName: string;
  questions: QuestionsExperience[];
  rateClassId: string;
  rateType: string;
  shceduling: any;
  searchId: number;
  selectDay: Date;
  serviceExtra: ExtraService[];
  subCategoryId: number;
  tax: number;
  taxPrice: number;
  taxes: [];
  taxNightsPriceTotal: number;
  title: string;
  totalPrice: number;
  totalPriceProf: number;
  tourId: string;
  updateDate: Date;
  hasReservationQuestions: boolean;
  cancellationPolicies: CancellationPoliciesExperience[];
}

export interface PayloadUpdateExperience {
  products: ProductPayloadUpdate[];
};

export interface ProductPayloadUpdate {
  market: number;
  providerId: string;
  nameAdapter: string;
  categoriesId: number[];
  productId: string;
  productName: string;
  destination: string;
  priceFrom: null;
  priceTo: null;
  arrivalDate: Date;
  departureDate: Date;
  others: OthersPayloadExperience;
  agencyId: number;
  bookingCode: string;
  id: number;
};

export interface OthersPayloadExperience {
  agedriver: any;
  serialized: any;
  maxRequestTimeOnSeconds: any;
  minNumResults: any;
  maxNumRestultsPerAdapter: any;
  tours: ToursPayloadExperience;
}

export interface ToursPayloadExperience {
  tours: {
    adults: number;
    children: number[];
  }
}

export interface PayloadExperience {
  agencyId: number;
  arrivalDate: Date;
  categoriesId: number[];
  city: string;
  departureDate: Date;
  destination: string;
  market: number;
  nationality: string;
  productName: string;
  others: OthersPayloadExperience;
  priceFrom: number;
  pricteTo: number;
  providerId: string;
  bookingCode: string;
  id: number;
}

export interface formExperience {
  arrivalDateDepartureDate: ArrivalDateDepartureDate;
  childsage: number[];
  destination: DestinationForm;
  qtyAdults: number;
  qtyChilds: number;
}

export interface ArrivalDateDepartureDate {
  start : Date;
  end: Date;
}

export interface DestinationForm {
  airport_iatas: string[];
  city_iata_code: string;
  city_name: string;
  country_iata_code: string;
  country_name: string;
  id: number;
  inmg_zones: string[];
  pic_mini: string;
}

export interface CancellationPoliciesExperience {
  amount: number;
  dateFrom: Date;
}

export interface DestinationExperience {
  iata_code: string;
  destination_info: DestinationInfoExperience
}

export interface DestinationInfoExperience {
  adults: number;
  agesAdults: number[];
  arrival: Date;
  childs: number;
  childsAges: number[];
  cityName: string;
  departure: Date;
  nights: number;
  position: number;
}

export interface OptionExperienceProduct {
  addonsIncluded: any;
  availableDates: any[];
  bookParam: string;
  cancellationPolicies: CancellationPoliciesExperience[];
  cancelattion_policy: CancellationPoliciesExperience[];
  currency: string;
  duration: string;
  language: string;
  netPriceBookingAddons: number;
  optionId: string;
  option_name: string;
  paxPrices: PaxPricesExperience[];
  prices: PricesExperience[];
  pricing: PricingExperience[];
  profility: Profility;
  questions: QuestionsExperience[];
  rateClass: string;
  sessions: string;
  totalPrice: number;
  typeAmount: string;
}

export interface PaxPricesExperience {
  ageFrom: number;
  ageTo: number;
  amount: number;
  paxType: string;
}

export interface PricingExperience {
  paxType: string;
  providerId: string;
  ageFrom: number;
  ageTo: number;
  blickoins: number;
  blickoinsFactor: number;
  creditBlickoins: number;
  creditFactor: number;
  netPriceFreeTax: number;
  netPriceProf: number;
  percentage: number;
  totalPriceFreeTax: number;
  totalPriceProf: number;
}

export interface PricesExperience {
  amountProf: number;
  boxOfficeAmountProf: number;
}

export interface QuestionsExperience {
  code: string;
  required: boolean;
  text: string;
}

export interface PaxProfilityExperience extends Profility {
  paxType: string;
}

export interface PaxesDataExperience {
  ageFrom: number;
  ageTo: number;
  originalAmount: number;
  passengerCount: number;
  paxType: string;
  total: number;
  unitPrice: number;
  priceData: PricesExperience;
  pricing: PricingExperience;
  profility: PaxProfilityExperience;
}

// RESERVA
export interface ReservationIExperienceProduct extends IProductReservationBase {
  id?: number;
  searchId: number;
  providerId: string;
  itinerary_id?: number;
  title: string;
  description?: string;
  categoryId?: number;
  productId?: number;
  destination: string;
  dateini: Date;
  dateEnd: Date;
  bookingCode: string;
  additionalInfo: ReservationExperienceAdditionalInfo;
}

export interface ReservationExperienceAdditionalInfo {
  tours: ToursReservationExperience[];
}

export interface ToursReservationExperience {
  netPrice: number;
  serialized: boolean;
  company: string;
  optionId: string;
  paxAdults: number;
  paxChildren: number;
  operationDateFrom: Date;
  operationDateTo: Date;
  iataCode: string;
  marketingId: number;
  currency: string;
  extras: ExtrasReservationExperience[];
  totalNetPrice: number;
  totalPrice: number;
  bookingCode: string;
  paxList: paxListReservationExperience[];
  question: QuestionsExperience[];
}

export interface ExtrasReservationExperience {
  id: number;
  price: number;
}

export interface paxListReservationExperience {
    clientId?: number;
    gender?: string;
    title?: string;
    birth_date?: string;
    firstName?: string,
    lastName?: string,
    identificationType?: null,
    identification?: string,
    age?: number,
    type?: string,
    email?: string,
    birthDate?: Date,
    country?: string,
    city?: string,
    state?: null,
    address?: string;
    phone?: string,
    phone2?: string,
    holder?: boolean,
    postalCode?: string,
    observations?: string,
    isCompleted?: null,
    idUnique?: number;
    relation_ship_catalogue_id?: number;
    nationality?: string;
}
